module.exports = __webpack_public_path__ + "img/service-icon-2.c5f61145.png";